import Component from 'vue-class-component';
import { SECTION_TYPES } from '@/content/values/sections';
import { Section } from '@/courses/models/section.model';
import {_HOMEWORKS_STORE, HOMEWORK_STATUS} from '@/homework/values/homeworks.values';
import { Mixins, Prop } from 'vue-property-decorator';
import { WidgetTeacherHomework } from '@/homework/models/widget-teacher-homework.model';
import { HomeworkPdfDraw } from '@/courses/mixins/homework-pdf-draw.mixin';
import { SEND_CURRENT_SHARED_TASK_EVENT } from '@/content/values/ed-presentation-mode.values';

@Component({})
export default class EdHomeworkCourseMaterialObject extends Mixins(HomeworkPdfDraw) {

  // @Prop() readonly section: Section;                     //Typescript upgrade
  // @Prop() readonly responseDraft: WidgetTeacherHomework;
  // @Prop() readonly courseId: number;
  declare readonly section: Section;
  declare readonly responseDraft: WidgetTeacherHomework;
  declare readonly courseId: number;

  get courseMaterial() {
    return {
      name: this.section.name,
      type: SECTION_TYPES.LESSON_PDF.code,
      text: this.section.text,
      assetsInfo: [{
        url: this.section.sectionMaterial.splicedUrl
      }]
    }
  }

  get showNotice(): boolean {
    return this.courseMaterial.assetsInfo[0].url === null;
  }

  get pdfUrl() : string {
    return this.section.sectionMaterial ? this.section.sectionMaterial.splicedUrl : this.section.section && this.section.section.sectionMaterial
            ? this.section.section.sectionMaterial.splicedUrl : '';
  }

  get documentHash() : string {
    return this.section.text;
  }

  get canSendResponse(): boolean {
    return typeof this.canResponse !== 'undefined'
        ? this.canResponse
        : this.section.status != HOMEWORK_STATUS.GRADED && this.section.status != HOMEWORK_STATUS.FINISHED;
  }

  mounted() {
    if(this.canSendResponse){
      this.callPdf();
    }else{
      this.cancelLoading();
      if(this.isPublisher && this.isPresentationTeacherMode){
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.UPDATE_SELETED_BOARD_INFO, {});
        this.$edEventBus.$emit(SEND_CURRENT_SHARED_TASK_EVENT);
      }
    }
  }

}